const BaseModel = require('../BaseModel');
const BaseEntity = require('./BaseEntity');

class EntitySelectable extends BaseEntity {
  static dataType = 'entity-selectable';

  constructor(json={}) {
    super(json);

    this.findValue = this.findValue.bind(this);
  }

  findValue(valueId) {
    this._mapped_values ||= this.values.reduce((obj, item) => Object.assign(obj, { [item.id]: item.value }), {});

    return(this._mapped_values[valueId]);
  }

  get isSelectable() { return(true) }
  get isScorable() { return(true) }
}

BaseModel.models[EntitySelectable.dataType] = EntitySelectable;
module.exports = EntitySelectable;
